import React from 'react';
import { Box } from '@mui/material';
import DosenTooltip from '../../../../components/ui/DosenTooltip';
import { SOURCE_COLOR, SOURCE_LABEL, type CapabilitySource } from './capabilitySource';

const TIP: Record<CapabilitySource, string> = {
  role: "One of this role's own capabilities, set by its team.",
  development: 'A Development capability, set by your organization for the roles it applies to.',
  standards: 'A Standards capability, set by your organization for the roles it applies to.'
};

/**
 * Where a capability comes from (Role, Development or Standards), in that
 * type's colour. `compact`: a dot, its name on hover, for rows with no room
 * to spare (the dashboard's Capability list).
 */
const SourceChip: React.FC<{ source: CapabilitySource; tip?: string; compact?: boolean }> = ({
  source,
  tip,
  compact = false
}) => (
  <DosenTooltip
    title={compact ? `${SOURCE_LABEL[source]}: ${tip ?? TIP[source]}` : tip ?? TIP[source]}
    placement="bottom"
  >
    {compact ? (
      <Box
        component="span"
        role="img"
        aria-label={`${SOURCE_LABEL[source]} capability`}
        data-testid={`source-chip-${source}`}
        sx={{ flexShrink: 0, width: 8, height: 8, borderRadius: '50%', bgcolor: SOURCE_COLOR[source] }}
      />
    ) : (
      <Box
        component="span"
        data-testid={`source-chip-${source}`}
        sx={{
          flexShrink: 0,
          display: 'inline-flex',
          alignItems: 'center',
          height: 18,
          px: '6px',
          borderRadius: '4px',
          border: `1px solid ${SOURCE_COLOR[source]}66`,
          bgcolor: `${SOURCE_COLOR[source]}1A`,
          color: SOURCE_COLOR[source],
          fontFamily: 'Inter, sans-serif',
          fontSize: 9.5,
          fontWeight: 700,
          letterSpacing: '0.06em',
          lineHeight: 1,
          textTransform: 'uppercase',
          whiteSpace: 'nowrap'
        }}
      >
        {SOURCE_LABEL[source]}
      </Box>
    )}
  </DosenTooltip>
);

export default SourceChip;
